import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-brand-icons',
	templateUrl:'./FontAwesomeBrandIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeBrandIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeBrandIconsPluginCompPage
{
	mdContent_925 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.icons.FontAwesomeBrandIcons;
\`\`\``;
	mdContent_926 = `\`\`\`java
new FontAwesome<>(FontAwesomeStyles.Brand, FontAwesomeBrandIcons.github);
new FontAwesome<>(FontAwesomeStyles.Brand, FontAwesomeBrandIcons.twitter);
new FontAwesome<>(FontAwesomeStyles.Brand, FontAwesomeBrandIcons.docker);
\`\`\``;
}
